import { history } from 'umi';
import { IGameData } from '../Summary/components/Games/types';

export const updateDetailsPagePathURL = (option: {
  companyId: string;
  tab: string;
  sbuTab?: string;
  search?: string;
}) => {
  const { companyId, tab, sbuTab, search } = option ?? {};
  if (!companyId || !tab) return;
  let path = `/intelligence/topCharts/companies/gamesDetails/${companyId}/${tab}${
    sbuTab ? `/${sbuTab}` : ''
  }`;
  if (search) {
    path += search;
  }
  history.replace(path);
};

/**
 * 游戏品类标签取值
 * 有 iegg 数据优先取用 iegg 数据，无 iegg 取 dataAi 数据。取值规则：一主两副
 */
export const getGamesGenresTag = (data: IGameData) => {
  if (!data) return [];

  let genres = [];

  const ieggMain = data.iegg_main_genre?.split('|')?.filter(Boolean);

  if (ieggMain?.length) {
    const sub = data.iegg_sub_genre?.split('|')?.slice(0, 2);
    genres = [ieggMain[0], ...sub]?.filter(Boolean);
  } else {
    const dataAiMain = data.annie_main_genre?.split('|')?.filter(Boolean);
    if (!dataAiMain?.length) return [];
    const sub = data.annie_sub_genre?.split('|')?.filter(Boolean)?.slice(0, 2);
    genres = [dataAiMain[0], ...sub]?.filter(Boolean);
  }

  return genres;
};
